import { createStore, applyMiddleware, compose } from 'redux'; // create a store to store the reducers (REDUX)
import rootReducer from './reducers'; // The reducer root
import thunk from 'redux-thunk';

export default function configureStore(initialState) {
return createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
  );
}


/** WEBPACK FOOTER **
 ** ./src/store.js
 **/


/** WEBPACK FOOTER **
 ** ./src/store.js
 **/